import React from "react";
import { connect } from "react-redux";
import ReactError from "lib/ReactError";

import { getFatalError } from "state/app/selectors";
import { fatalError } from "state/app/actions";

/**
 * Catch exceptions thrown below here in the tree, and dispatch
 *   fatal error actions instead of letting react crash outright.
 */
class FatalErrorBoundary extends React.Component {
  
  componentDidCatch(error, info) {
    this.props.fatalError(new ReactError(error, info));
  }
  
  render() {
    return this.props.hasFatalError ? null : this.props.children;
  }
  
}

export default connect(
  state => ({
    hasFatalError: getFatalError(state) !== null
  }),
  { fatalError }
)(FatalErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/FatalErrorBoundary.js